import { __assign } from "tslib";
export var urlMappingsArrayToObject = function (urlMappingsEntities) {
    if (!Array.isArray(urlMappingsEntities)) {
        return;
    }
    return urlMappingsEntities.reduce(function (currentUrlMappings, _a) {
        var _b;
        var languageKey = _a.languageKey, urlMappings = _a.urlMappings;
        return (__assign(__assign({}, currentUrlMappings), (_b = {}, _b[languageKey] = urlMappings, _b)));
    }, {});
};
//# sourceMappingURL=url-mappings-array-to-object.js.map